module.exports = __webpack_public_path__ + "static/media/june2020_2.5678365b.jpeg";